module.exports = [
  {
    type: 'item',
    isHeader: true,
    name: 'Sistema de Serviços Patrimoniais'
  },
  {
    type: 'tree',
    icon: 'fa fa-cogs',
    grupos: [
      'admin',
      'oi',
      'adminVTAL'
    ],
    name: 'Simulação Preventivas',
    items: [
      {
        type: 'item',
        icon: 'fa fa-circle-o',
        grupos: [
          'admin',
          'oi',
          'adminVTAL'
        ],
        name: 'Quadro Geral',
        router: {
          name: 'SimulacaoGeral'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-upload',
        grupos: [
          'admin',
          'oi',
          'adminVTAL'
        ],
        name: 'Importar Preventivas',
        router: {
          name: 'ImportarPreventivas'
        }
      }
    ]
  },
  {
    type: 'item',
    icon: 'fa fa-bar-chart',
    grupos: [
      'admin',
      'oi'
    ],
    name: 'SLA',
    router: {
      name: 'ListarSla'
    }
  },
  {
    type: 'tree',
    icon: 'fa fa-bell',
    grupos: [
      'admin',
      'oi',
      'adminVTAL'
    ],
    name: 'Notificações',
    items: [
      {
        type: 'item',
        icon: 'fa fa-circle-o',
        grupos: [
          'admin',
          'oi',
          'adminVTAL'
        ],
        name: 'Adicionar notificação',
        router: {
          name: 'InserirNotificacao'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-table',
        grupos: [
          'admin',
          'oi',
          'adminVTAL'
        ],
        name: 'Listar notificações',
        router: {
          name: 'ListarNotificacoes'
        }
      }
    ]
  },
  {
    type: 'tree',
    icon: 'fa fa-fw fa-usd',
    grupos: [
      'admin',
      'oi',
      'adminVTAL'
    ],
    name: 'Extracontratual',
    items: [
      {
        type: 'item',
        icon: 'fa fa-circle-o',
        grupos: [
          'admin',
          'oi',
          'adminVTAL'
        ],
        name: 'Aplicar',
        router: {
          name: 'ListarFechamentoExtra'
        }
      },
      {
        type: 'item',
        icon: 'fa fa-table',
        grupos: [
          'admin',
          'oi',
          'adminVTAL'
        ],
        name: 'Listar',
        router: {
          name: 'ExibirFechamentoExtra'
        }
      }
    ]
  },
  {
    type: 'tree',
    icon: 'fa fa-fw fa-usd',
    grupos: [
      'admin',
      'oi',
      'adminVTAL'
    ],
    name: 'Glosa',
    items: [
      {
        type: 'item',
        icon: 'fa fa-circle-o',
        grupos: [
          'admin',
          'oi',
          'adminVTAL'
        ],
        name: 'Aplicar',
        router: {
          name: 'AplicarGlosaFranquias'
          // name: 'ListarFechamentoExtra'
        }
      },
    //   {
    //     type: 'item',
    //     icon: 'fa fa-table',
    //     grupos: [
    //       'admin',
    //       'oi',
    //       'adminVTAL'
    //     ],
    //     name: 'Listar',
    //     router: {
    //       name: 'ExibirFechamentoExtra'
    //     }
    //   }
    ]
  },
  {
    type: 'item',
    icon: 'fa fa-file-excel-o',
    grupos: [
      'admin',
      'oi',
      'adminVTAL'
    ],
    name: 'Planilhas',
    router: {
      name: 'Planilhas'
    }
  },
  {
    type: 'item',
    icon: 'fa fa-building',
    name: 'Novo SSP',
    grupos: [
      'admin',
      'oi',
      'adminVTAL'
    ],
    router: {
      name: 'RedirecionarAdministrativo'
    }
  }
]



// WEBPACK FOOTER //
// ./src/lib/slideMenuItems.js